<!--Just some background -->

<!--This is going to be an ai chat interface for a task managemnt system-->
<!--This is an old app that runs on vuetify v1.6 -->

<!--chat example : { "id": 7, "fkTaskId": 239257, "fkUserId": 1, "createdAt": "2025-10-30T11:40:24.000Z", "title": "New Chat", "lastModelId": 7 }-->
<!--model example : {"id": 4, "ecosystem": "Google", "modelId": "gemFla.25", "name": "Gemini Flash 2.5", "isToolsEnabled": 1, "isActive": 0}-->
<template>
  <div style="height: 100%" class="of-y pa-2">
    <v-card class="c-d-flex c-flex-column of-y" style="max-height: 100%"
            @dragover.prevent="$event.dataTransfer.dropEffect = 'move'"
            @drop.prevent="dropEvent"
            v-pdrop="(e) => dropEvent(e)">
      
      <div class="c-flex-grow-0 primary white--text title" @click="$store.state.ai.showTaskChat = !$store.state.ai.showTaskChat" style="cursor: pointer">
        <div class="c-d-flex c-align-center pl-2 py-1">
          <v-tooltip bottom>
            <template #activator="{on}">
              <v-btn icon flat small color="white" class="pa-0 ma-0" v-on="on">
                <img src="/icons/aiLogo.svg" class="nav-item" style="height: 24px">
              </v-btn>
            </template>
            <span>Toggle AI Chat</span>
          </v-tooltip>
          <div class="pa-2 ">
            AI Chat
          </div>
          <v-icon right color="white" >chevron_right</v-icon>
        </div>
        <v-divider></v-divider>
      </div>
      
      <div class="c-flex-grow-0">
        <div class="pa-2">
          <v-layout row align-center>
            <!-- Chat Selector (Left) -->
            <v-flex
              @click="showChatSelector = true"
              style="cursor: pointer"
              class="px-3"
            >
              <v-layout row align-center>
                <v-icon small class="mr-2 grey--text text--lighten-1">chat</v-icon>
                <div>
                  <div class="caption grey--text text--lighten-1">Chat</div>
                  <div class="body-2" :style="{color: 'var(--on-surface)'}">{{ selectedChat ? selectedChat.title : 'Select Chat' }}</div>
                </div>
              </v-layout>
            </v-flex>

<!-- New Chat Button -->
            <v-flex shrink>
              <v-btn
                icon
                small
                flat
                @click="createNewChat"
                :disabled="startingUp"
              >
                <v-icon small>add</v-icon>
              </v-btn>
            </v-flex>

            <v-divider vertical class="mx-2"></v-divider>

<!-- Model Selector (Right) -->
            <v-flex
              @click="showModelSelector = true"
              style="cursor: pointer"
              class="px-3"
            >
              <v-layout row align-center>
                <v-icon small class="mr-2 grey--text text--lighten-1">memory</v-icon>
                <div>
                  <div class="caption grey--text text--lighten-1">Model</div>
                  <div class="body-2" :style="{color: 'var(--on-surface)'}">{{ selectedModel ? selectedModel.name : 'Select Model' }}</div>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <v-divider></v-divider>
      </div>
      
      <!-- Messages Area -->
      <div class="c-flex-grow-1 fill-height of-y pa-3" ref="messagesContainer" style="overflow-y: auto">
        <div v-if="messages.length === 0" class="text-center grey--text mt-5">
          <v-icon large class="mb-2">chat_bubble_outline</v-icon>
          <div>No messages yet. Start a conversation!</div>
        </div>

        <div v-for="(msg, index) in messages" :key="msg.id || index" class="mb-2">
          <!-- System Message -->
          <div v-if="msg.role === 'system'" class="my-2">
            <div class="caption grey--text c-d-flex c-align-center">
                <v-icon x-small left color="grey">info</v-icon>
              System prompt active
            </div>
          </div>

          <!-- User Message -->
          <!-- Skip rendering user messages that are just tool results (empty content) -->
          <div v-else-if="msg.role === 'user' && (msg.content || msg.attachments || msg.mails)">
            <!-- Show message content if present -->
            <message-bubble
              v-if="msg.content"
              :content="msg.content"
              :is-user="true"
              :time="formatTime(msg.createdAt)"
            />
            <!-- Show attachments below message, aligned to the right -->
            <div v-if="msg.attachments && msg.attachments.length > 0" :class="msg.content ? 'mt-1 mb-2' : 'mb-2'">
              <v-layout row wrap justify-end>
                <!-- Show time if no message content -->
                <div v-if="!msg.content" class="caption grey--text mr-2 mt-2">
                  {{ formatTime(msg.createdAt) }}
                </div>
                <v-chip
                  v-for="(attachment, idx) in msg.attachments"
                  :key="idx"
                  class="ma-1 compact-chip"
                  small
                  :color="attachment.error ? 'error' : 'grey lighten-2'"
                >
                  <v-icon left small>
                    {{ attachment.error ? 'warning' : getAttachmentIcon(attachment) }}
                  </v-icon>
                  <span class="caption">
                    {{ truncateText(attachment.filename) }}
                    <span v-if="attachment.error"> (failed)</span>
                  </span>
                </v-chip>
              </v-layout>
            </div>
            <!-- Show mails below message, aligned to the right -->
            <div v-if="msg.mails && msg.mails.length > 0" :class="msg.content || msg.attachments ? 'mt-1 mb-2' : 'mb-2'">
              <v-layout row wrap justify-end>
                <!-- Show time if no message content and no attachments -->
                <div v-if="!msg.content && !msg.attachments" class="caption grey--text mr-2 mt-2">
                  {{ formatTime(msg.createdAt) }}
                </div>
                <v-chip
                  v-for="(mail, idx) in msg.mails"
                  :key="`mail-${idx}`"
                  class="ma-1 compact-chip"
                  small
                  :color="mail.error ? 'error' : 'grey lighten-2'"
                >
                  <v-icon left small>
                    {{ mail.error ? 'warning' : 'mail_outline' }}
                  </v-icon>
                  <span class="caption">
                    {{ truncateText(mail.subject || 'No Subject') }}
                    <span v-if="mail.error"> (failed)</span>
                  </span>
                </v-chip>
              </v-layout>
            </div>
          </div>

          <!-- Tool Results Message (from user role) -->
          <div v-else-if="msg.role === 'user' && !msg.content && msg.toolResults" class="my-2">
            <div class="caption grey--text c-d-flex c-align-center">
              <v-icon x-small left color="grey">check_circle</v-icon>
              Tool results provided ({{ msg.toolResults.length }} result{{ msg.toolResults.length !== 1 ? 's' : '' }})
            </div>
          </div>

          <!-- Assistant Message -->
          <div v-else-if="msg.role === 'assistant'">
            <!-- Tool calls being executed (empty content with toolCalls) -->
            <div v-if="!msg.content && msg.toolCalls" class="my-2">
              <div class="caption grey--text c-d-flex c-align-center">
                <v-icon x-small left color="orange">build</v-icon>
                <span class="ml-1">Executing {{ msg.toolCalls.length }} tool{{ msg.toolCalls.length !== 1 ? 's' : '' }}:</span>
                <span class="ml-1">{{ msg.toolCalls.map(tc => tc.name).join(', ') }}</span>
                <span v-if="msg.totalTokens && msg.totalTokens > 0" class="ml-2">
                  • {{ msg.totalTokens }} tokens
                </span>
              </div>
            </div>

            <!-- Normal assistant message with content -->
            <message-bubble
              v-else-if="msg.content"
              :content="renderMarkdown(msg.content)"
              :raw-content="msg.content"
              :is-user="false"
              :time="formatTime(msg.createdAt)"
              :tokens="msg.totalTokens"
            />

            <!-- Fallback for any other assistant message type (shouldn't happen) -->
            <div v-else class="my-2">
              <div class="caption grey--text c-d-flex c-align-center">
                <v-icon x-small left color="grey">info</v-icon>
                Processing...
              </div>
            </div>
          </div>
        </div>

        <!-- Loading Indicator -->
        <div v-if="loading" class="mb-2">
          <v-layout row align-center>
            <v-progress-circular indeterminate size="16" width="2" class="mr-2"></v-progress-circular>
            <span class="caption grey--text">Thinking...</span>
          </v-layout>
        </div>
      </div>

      <!-- Input Area -->
      <div class="c-flex-grow-0">
        <v-divider></v-divider>

        <!-- Document Attachments Display -->
        <div v-if="viewTaskDocuments.length > 0" class="px-2 pt-2" style="max-width: 100%; overflow-x: hidden;">
          <v-layout row wrap>
            <v-chip
              v-for="(doc, index) in viewTaskDocuments"
              :key="index"
              close
              @input="removeDocument(index)"
              class="ma-1 compact-chip"
              small
            >
              <v-icon left small>
                {{ doc.type === 'taskPdf' ? 'picture_as_pdf' :
                   doc.type === 'taskImage' ? 'image' :
                   doc.type === 'taskAudio' ? 'audiotrack' : 'attach_file' }}
              </v-icon>
              {{ truncateText(doc.filename) }}
            </v-chip>
          </v-layout>
        </div>

        <!-- Email Attachments Display -->
        <div v-if="viewTaskMails.length > 0" class="px-2 pt-2" style="max-width: 100%; overflow-x: hidden;">
          <v-layout row wrap>
            <v-chip
              v-for="(mail, index) in viewTaskMails"
              :key="`mail-${index}`"
              close
              @input="removeMail(index)"
              class="ma-1 compact-chip"
              small
            >
              <v-icon left small>mail_outline</v-icon>
              {{ truncateText(mail.subject) }}
            </v-chip>
          </v-layout>
        </div>

        <div class="pa-2">
          <v-layout row align-center>
            <v-flex class="c-flex-grow-1">
              <v-textarea
                ref="messageTextArea"
                v-model="currentMessage"
                class="py-0 my-0 message-maker"
                single-line
                solo
                flat
                hide-details
                label="Type your message here"
                :rows="1"
                :auto-grow="true"
                :disabled="loading || !selectedChat || !selectedModel"
                :loading="loading"
                @keydown="handleKeydown"
              ></v-textarea>
            </v-flex>
            <v-flex shrink class="ml-2">
              <v-btn
                icon
                color="primary"
                :disabled="(!currentMessage.trim() && !viewTaskDocuments.length && !viewTaskMails.length) || loading || !selectedChat || !selectedModel"
                @click="sendMessage"
              >
                <v-icon>send</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-card>

    <!-- Chat Selector Dialog -->
    <app-input-dlg
      :show-dialog="showChatSelector"
      title="Select Chat"
      :cancel-button="true"
      :show-input-box="false"
      @dismiss="showChatSelector = false"
      :width="600"
      :body-padding="false"
    >
      <template #body>
        <div style="max-height: 400px; overflow-y: auto" class="pa-2">
          <v-list dense>
            <v-list-tile
              v-for="chat in sortedChats"
              :key="chat.id"
              @click="selectChat(chat)"
              :class="{'primary white--text': selectedChat && selectedChat.id === chat.id}"
              ripple
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ chat.title }}</v-list-tile-title>
                <v-list-tile-sub-title :class="selectedChat && selectedChat.id === chat.id ? 'white--text' : ''">
                  {{ formatDate(chat.createdAt) }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon v-if="selectedChat && selectedChat.id === chat.id" color="white">check</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>
      </template>
    </app-input-dlg>

    <!-- Model Selector Dialog -->
    <app-input-dlg
      :show-dialog="showModelSelector"
      title="Select Model"
      :cancel-button="true"
      :show-input-box="false"
      @dismiss="showModelSelector = false"
      :width="600"
      :body-padding="false"
    >
      <template #body>
        <div style="max-height: 400px; overflow-y: auto" class="pa-2">
          <v-list dense>
            <v-list-tile
              v-for="model in activeModels"
              :key="model.id"
              @click="selectModel(model)"
              :class="{'secondary white--text': selectedModel && selectedModel.id === model.id}"
              ripple
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ model.name }}
                  <span v-if="model.isToolsEnabled" class="caption ml-2" :class="selectedModel && selectedModel.id === model.id ? 'white--text' : 'green--text'">(Tools Enabled)</span>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon v-if="selectedModel && selectedModel.id === model.id" color="white">check</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>
      </template>
    </app-input-dlg>
  </div>
</template>

<script>
import InputDlg from "@/components/General/InputDlg";
import MessageBubble from "./MessageBubble.vue";
import {socket} from "@/feedSocket";
import {mapGetters} from "vuex";
import MarkdownIt from 'markdown-it';
import mime from 'mime';

const md = new MarkdownIt({
  html: true, // Enable HTML in source (safer than it sounds - XSS is still escaped)
  linkify: true,
  breaks: true,
  typographer: true
});

// Customize table rendering to add wrapper div for better styling
const defaultTableRender = md.renderer.rules.table_open || function(tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options);
};

md.renderer.rules.table_open = function (tokens, idx, options, env, self) {
  return '<div class="table-wrapper">' + defaultTableRender(tokens, idx, options, env, self);
};

const defaultTableCloseRender = md.renderer.rules.table_close || function(tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options);
};

md.renderer.rules.table_close = function (tokens, idx, options, env, self) {
  return defaultTableCloseRender(tokens, idx, options, env, self) + '</div>';
};

export default {
  components: {
    appInputDlg: InputDlg,
    MessageBubble
  },
  props: {
    task: Object,
  },
  data() {
    return {
      console,
      startingUp: false,
      chats: [],
      models: [],
      selectedChat: null,
      selectedModel: null,
      showChatSelector: false,
      showModelSelector: false,
      messages: [],
      currentMessage: '',
      loading: false,
      viewTaskDocuments: [],  // For storing dropped documents
      viewTaskMails: []  // For storing dropped emails
    }
  },
  mounted() {
    this.startup()
    this.setupSocketReconnection()
  },
  beforeDestroy() {
    if (this.selectedChat)
      this.unSubChatMessages(this.selectedChat.id)
    // Remove reconnect listener
    socket.off('connect', this.handleSocketReconnect)
  },
  watch: {
    selectedChat: {
      immediate: true,
      handler(val, oldVal) {
        if (oldVal?.id) {
          this.unSubChatMessages(oldVal.id)
        }
        
        if (val) {
          this.chatChanged()
          this.subChatMessages(val.id)
        }
      }
    }
  },
  methods: {
    setupSocketReconnection() {
      // Listen for socket reconnection
      socket.on('connect', this.handleSocketReconnect)
    },

    handleSocketReconnect() {
      console.log('Socket reconnected - rejoining chat room');
      // Re-subscribe to the current chat if one is selected
      if (this.selectedChat) {
        this.subChatMessages(this.selectedChat.id)
      }
    },

    async test() {
      try {
        const res = await this.$newReq('POST', 'task/ai/chat/test', {taskId: this.task.taskID, chat: this.selectedChat})
        console.log(res)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      }
    },

    unSubChatMessages(chatId) {
      const roomName = `tcm-${this.userInfo.entityID}-${chatId}`;
      socket.emit('taskChatLeaveReq', roomName);
      socket.off(roomName, this.socketMessage);
    },

    subChatMessages(chatId) {
      const roomName = `tcm-${this.userInfo.entityID}-${chatId}`;
      // IMPORTANT: Remove any existing listeners first to prevent duplicates
      socket.off(roomName, this.socketMessage);
      // Then add the listener
      socket.on(roomName, this.socketMessage);
      // Finally, join the room
      socket.emit('taskChatJoinReq', roomName);
    },
    
    socketMessage({data: {type, data}}) {
      console.log('Socket message:', type, data);
      if (type === 'documentErrors') {
        // Handle document processing errors
        console.error('Document processing errors:', data);

        // Show error notification to user
        const errorMessage = data.errors.map(err =>
          `${err.filename}: ${err.error}`
        ).join('\n');

        this.$snack.showMessage({
          message: `Failed to process document(s):\n${errorMessage}`,
          color: 'error',
          timeout: 8000
        });
      } else if (type === 'message') {
        // Parse toolCalls and toolResults if they're strings
        if (data.toolCalls && typeof data.toolCalls === 'string') {
          try {
            data.toolCalls = JSON.parse(data.toolCalls);
          } catch (e) {
            console.error('Failed to parse toolCalls:', e);
          }
        }
        if (data.toolResults && typeof data.toolResults === 'string') {
          try {
            data.toolResults = JSON.parse(data.toolResults);
          } catch (e) {
            console.error('Failed to parse toolResults:', e);
          }
        }
        // Parse metadata for attachments and mails
        if (data.metadata) {
          if (typeof data.metadata === 'string') {
            try {
              data.metadata = JSON.parse(data.metadata);
            } catch (e) {
              console.error('Failed to parse metadata:', e);
            }
          }
          if (data.metadata) {
            if (data.metadata.attachments) {
              data.attachments = data.metadata.attachments;
            }
            if (data.metadata.mails) {
              data.mails = data.metadata.mails;
            }
          }
        }
        // Add message to the list
        this.messages.push(data);
        // Scroll to bottom
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } else if (type === 'titleUpdate') {
        // Update chat title in the list
        const chat = this.chats.find(c => c.id === data.chatId);
        if (chat) {
          chat.title = data.title;
        }
        // If this is the currently selected chat, the UI will update automatically via reactivity
      }
    },

    handleKeydown(event) {
      // Ctrl+Enter to send
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault();
        this.sendMessage();
      }
      // Prevent Enter from creating new line (single-line behavior)
      else if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    },

    dropEvent(e) {
      try {
        const dropData = JSON.parse(e.dataTransfer.getData("text") || '{}')

        // Task Document
        if (dropData?.dragType === 'document' && dropData.data) {
          const taskDocument = this.task.structure.documents.find(v => v.documentDBID === dropData.data)

          let filename = (taskDocument.alias || taskDocument.fileName).trim()

          if (filename.split('.').pop().toLowerCase() !== (taskDocument.extention || '').toLowerCase())
            filename = `${filename}.${taskDocument.extention}`

          const mimeType = mime.lookup(filename)
          const mimeTypeCat = mimeType.split('/').shift()

          let attType = null

          if (mimeType === 'application/pdf')
            attType = 'taskPdf'
          else if (mimeTypeCat === 'image')
            attType = 'taskImage'
          else if (mimeTypeCat === 'audio')
            attType = 'taskAudio'
          else attType = 'taskFile'

          this.viewTaskDocuments.push({
            type: attType,
            mime: mimeType,
            filename,
            documentDbId: taskDocument.documentDBID,
            documentId: taskDocument.documentID
          })
        }
        // Email Drop
        else if (dropData?.dragType === 'mail' && dropData.data) {
          const mail = dropData.data;

          // Check if mail is already added
          if (!this.viewTaskMails.find(m => m.mailDBID === mail.mailDBID)) {
            // Add mail to the list
            this.viewTaskMails.push({
              mailDBID: mail.mailDBID,
              mailFile: mail.mailFile,
              subject: mail.subject || 'No Subject',
              from: mail.from || mail.fromString || 'Unknown Sender',
              mailDate: mail.mailDate,
              snippet: mail.snippet || '',
              attachmentCount: mail.attachments?.length || 0
            });
          }
        }
      } catch (e) {
        // console.log(e)
      }
    },

    removeDocument(index) {
      this.viewTaskDocuments.splice(index, 1);
    },

    removeMail(index) {
      this.viewTaskMails.splice(index, 1);
    },

    async sendMessage() {
      const message = this.currentMessage.trim();

      // Check if we have something to send (message, documents, or emails)
      if (!message && !this.viewTaskDocuments.length && !this.viewTaskMails.length) return;
      if (this.loading) return;

      // Store attachments and mails before clearing
      const attachmentsToSend = [...this.viewTaskDocuments];
      const mailsToSend = [...this.viewTaskMails];

      this.loading = true;

      try {
        const payload = {
          chatId: this.selectedChat.id,
          message: message || '',  // Send empty string if no text but has documents/mails
          modelId: this.selectedModel.id
        };

        // Add task attachments if there are any
        if (attachmentsToSend.length) {
          payload.taskAttachments = attachmentsToSend;
        }

        // Add task mails if there are any
        if (mailsToSend.length) {
          payload.taskMails = mailsToSend;
        }

        await this.$newReq('POST', 'task/ai/chat/send', payload);

        // Only clear on successful send
        this.currentMessage = '';
        this.viewTaskDocuments = [];
        this.viewTaskMails = [];

        // Messages will be added via socket
      } catch (e) {
        console.error('Send message error:', e);

        // Show more detailed error message
        let errorMessage = 'Failed to send message';
        if (e.response && e.response.data && e.response.data.error) {
          errorMessage = e.response.data.error;
        } else if (e.message) {
          errorMessage = e.message;
        }

        this.$snack.showMessage({
          message: `Error: ${errorMessage}`,
          color: 'error',
          timeout: 6000
        });

        // Don't clear attachments/mails on error so user can retry
      } finally {
        this.loading = false;
      }
    },

    async loadMessages() {
      if (!this.selectedChat) return;

      try {
        const {messages} = await this.$newReq('POST', 'task/ai/chat/messages', {
          chatId: this.selectedChat.id
        });

        // Parse toolCalls, toolResults, and metadata for each message
        const parsedMessages = (messages || []).map(msg => {
          if (msg.toolCalls && typeof msg.toolCalls === 'string') {
            try {
              msg.toolCalls = JSON.parse(msg.toolCalls);
            } catch (e) {
              console.error('Failed to parse toolCalls:', e);
            }
          }
          if (msg.toolResults && typeof msg.toolResults === 'string') {
            try {
              msg.toolResults = JSON.parse(msg.toolResults);
            } catch (e) {
              console.error('Failed to parse toolResults:', e);
            }
          }
          // Parse metadata for attachments
          if (msg.metadata) {
            if (typeof msg.metadata === 'string') {
              try {
                msg.metadata = JSON.parse(msg.metadata);
              } catch (e) {
                console.error('Failed to parse metadata:', e);
              }
            }
            if (msg.metadata) {
              if (msg.metadata.attachments) {
                msg.attachments = msg.metadata.attachments;
              }
              if (msg.metadata.mails) {
                msg.mails = msg.metadata.mails;
              }
            }
          }
          return msg;
        });

        this.messages = parsedMessages;
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } catch (e) {
        console.error('Load messages error:', e);
        this.$snack.networkError();
      }
    },

    scrollToBottom() {
      const container = this.$refs.messagesContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },

    selectChat(chat) {
      this.selectedChat = chat;
      this.showChatSelector = false;
      this.viewTaskDocuments = []; // Clear any attachments when switching chats
      this.viewTaskMails = []; // Clear any mails when switching chats
      this.loadMessages();
    },

    selectModel(model) {
      this.selectedModel = model;
      this.showModelSelector = false;
    },

    async createNewChat() {
      try {
        const result = await this.$newReq('POST', 'task/ai/chat/create', {
          taskId: this.task.taskID,
          modelId: this.selectedModel?.id || null
        });

        const newChat = {
          ...result.chat,
          createdAt: new Date(result.chat.createdAt)
        };

        this.chats.push(newChat);
        this.selectedChat = newChat;
        this.messages = [];
        this.viewTaskDocuments = []; // Clear any attachments when starting a new chat
        this.viewTaskMails = []; // Clear any mails when starting a new chat
      } catch (e) {
        console.error('Create chat error:', e);
        this.$snack.networkError();
      }
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },

    formatTime(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },

    truncateText(text, maxLength = 50) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    renderMarkdown(content) {
      if (!content) return '';
      return md.render(content);
    },

    getAttachmentIcon(attachment) {
      if (attachment.error) return 'error';

      if (attachment.type === 'taskPdf') return 'picture_as_pdf';
      if (attachment.type === 'taskImage') return 'image';
      if (attachment.type === 'taskAudio') return 'audiotrack';
      if (attachment.type === 'taskFile') {
        // Check mime type for more specific icons
        if (attachment.mime && attachment.mime.startsWith('text/')) return 'description';
        if (attachment.mime && attachment.mime.includes('spreadsheet')) return 'table_chart';
        if (attachment.mime && attachment.mime.includes('presentation')) return 'slideshow';
        if (attachment.mime && attachment.mime.includes('word')) return 'article';
      }
      return 'attach_file';
    },

    async chatChanged() {
      // TODO get a default model fore the workflow
      this.selectedModel = this.models.find(v => v.id === this.selectedChat.lastModelId) || null;
      
      if (!this.selectedModel) {
        this.selectedModel = this.models.find(v => v.id === 1) || this.models.at(0);
      }
      await this.loadMessages();
    },

    async startup() {
      try {
        this.startingUp = true
        const {chats} = await this.$newReq('POST', 'task/ai/chat/startup', {taskId: this.task.taskID})
        for (const chat of chats) {
          chat.createdAt = new Date(chat.createdAt)
        }
        // Use models from userInfo instead of fetching from server
        this.models = this.userInfo.chatModels || []
        this.chats = chats

        this.selectedChat = this.sortedChats.at(-1)

      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.startingUp = false
      }

    }
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    
    sortedChats() {
      return [...this.chats].sort((a,b) => a.createdAt - b.createdAt)
    },

    activeModels() {
      // Models from userInfo.chatModels are already filtered to active models only
      return this.models
    }
  },
}
</script>

<style scoped>
/* Styles moved to MessageBubble.vue component */

/* Additional styles for document attachments */
.v-chip {
  cursor: default;
}

.v-chip .v-icon {
  opacity: 0.8;
}

.v-chip.error {
  opacity: 0.9;
}

/* Compact chip styling to reduce vertical padding */
.compact-chip {
  height: 22px !important;
  padding: 0 8px !important;
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.compact-chip >>> .v-chip__content {
  padding: 0 !important;
  line-height: 22px !important;
}

.compact-chip >>> .v-icon {
  font-size: 16px !important;
  margin-right: 4px !important;
  margin-left: -4px !important;
}

.compact-chip >>> .v-chip__close {
  font-size: 16px !important;
  margin: 0 -4px 0 2px !important;
}
</style>